import { createContext, useContext, type ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { useAttendanceClock } from '../hooks/useAttendanceClock';

type AttendanceClockController = ReturnType<typeof useAttendanceClock>;

const AttendanceClockContext = createContext<AttendanceClockController | null>(null);

export function AttendanceClockProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const clockState = useAttendanceClock(user);

  return (
    <AttendanceClockContext.Provider value={clockState}>
      {children}
    </AttendanceClockContext.Provider>
  );
}

export function useSharedAttendanceClock(): AttendanceClockController {
  const clockState = useContext(AttendanceClockContext);
  if (!clockState) {
    throw new Error('useSharedAttendanceClock must be used within AttendanceClockProvider');
  }
  return clockState;
}
